import React from 'react';
import Commonmark from 'react-commonmark';

import { Trans } from '@lingui/macro';

import {
  BREAKPOINTS,
  disabledColor,
  getColWidthCalc,
  primaryColor,
  unit,
} from '@zego/theme';

import H1 from '@zego/components/atoms/H1';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import Button from '@zego/components/button/ButtonLink';
import ContentContainer from '@zego/components/ContentContainer';
import LegalsContainer from '@zego/components/LegalsContainer';
import Link from '@zego/components/Link';

const renderers = {
  // eslint-disable-next-line react/display-name
  Link: node => (
    <Link href={node.href} key={node.nodeKey}>
      {node.children}
    </Link>
  ),
};

const LegalPageLayout = ({ title, subtitle, body }) => (
  <>
    <ContentContainer css={{ paddingBottom: unit(4) }}>
      <View
        css={{
          [BREAKPOINTS.medium]: {
            width: getColWidthCalc(12, 20, 8),
            margin: '0 auto',
          },
        }}
      >
        <H1 css={{ fontSize: 42, marginBottom: unit(1) }}>{title}</H1>
        {subtitle ? (
          <RegularText
            css={{ fontSize: 18, fontWeight: 600, color: disabledColor(10) }}
          >
            {subtitle}
          </RegularText>
        ) : null}
        <Spacer height={unit(10)} />
        <LegalsContainer>
          <Commonmark source={body} renderers={renderers} />
        </LegalsContainer>

        <div
          css={{
            borderTop: `1px solid ${disabledColor(4)}`,
            marginTop: unit(6),
            paddingTop: unit(4),
            textAlign: 'center',
          }}
        >
          <RegularText css={{ color: disabledColor(10) }}>
            <Trans id="Legal Page / Info">
              If you choose to exercise your legal rights, we have a form for
              making a request
            </Trans>
          </RegularText>
          <Spacer height={unit(3)} />
          <Button
            backgroundColor={primaryColor(2)}
            color={primaryColor(8)}
            href="https://app-de.onetrust.com/app/#/webform/b465b7ff-18b1-4e10-8f8c-58913317f088"
          >
            <Trans id="Legal Page / Exercise your rights">
              Exercise your rights
            </Trans>
          </Button>
          <Spacer height={unit(1)} />
          <RegularText css={{ color: disabledColor(10), fontSize: 14 }}>
            <Trans id="Legal Page / External website link">
              (this will take you to an external website)
            </Trans>
          </RegularText>
        </div>
      </View>
    </ContentContainer>
  </>
);

export default LegalPageLayout;
